import { RouteItem } from '@aipb/frame/model';

import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'fr-sidebar-route-menu',
  templateUrl: './sidebar-route-menu.component.html',
  styleUrls: ['./sidebar-route-menu.component.scss'],
  exportAs: 'routeMenu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule, RouterLink]
})
export class SidebarRouteMenuComponent {
  @Input() routes: RouteItem[] = [];

  // @ts-expect-error foo
  @ViewChild(MatMenu, { static: true }) menu: MatMenu;
}
